import { render } from "./Copy.vue?vue&type=template&id=d8eea24c"
const script = {}

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__